import { SET_CUSTOMER } from "../../types";

const setCustomer = (customer) => (dispatch) => {
  dispatch({ type: SET_CUSTOMER, customer });
};

export { setCustomer };
